module.exports = __webpack_public_path__ + "static/media/ic_cart.9d1f95a3.svg";